export default "__VITE_ASSET__BCIY5hyA__"